import React from 'react'

import TableLogs from '../../../components/table/users/TableLogs'

function LogsPage() {
  return <TableLogs />
}

export default LogsPage
